export const SET_AVERAGE_PRICE_CHIPS_DATA = 'SET_AVERAGE_PRICE_CHIPS_DATA';
export const SET_AVERAGE_PRICE_NOTICES = 'SET_AVERAGE_PRICE_NOTICES';
export const SET_AVERAGE_PRICE_STATISTIC_INFO = 'SET_AVERAGE_PRICE_STATISTIC_INFO';
export const SET_AVERAGE_PRICE_CHART_DATA = 'SET_AVERAGE_PRICE_CHART_DATA';
export const SET_AVERAGE_PRICE_SIMILAR_CARS_DATA = 'SET_AVERAGE_PRICE_SIMILAR_CARS_DATA';
export const SET_AVERAGE_PRICE_RESPONSE_TYPE = 'SET_AVERAGE_PRICE_RESPONSE_TYPE';
export const SET_AVERAGE_PRICE_META_DATA = 'SET_AVERAGE_PRICE_META_DATA';
export const RESET_AVERAGE_PRICE_RESPONSE = 'RESET_AVERAGE_PRICE_RESPONSE';
export const SET_LOADER_STATE = 'SET_LOADER_STATE';
